import {TranslatePipe} from '@ngx-translate/core';
import {Component, Input, OnInit} from '@angular/core';
import {ShoppingCartComponent} from '@app/common/ui-kits';
import {Tour} from '@app/common/interfaces/tour';

@Component({
  selector: 'app-tour-item',
  templateUrl: './tour-item.component.html',
  styleUrls: ['./tour-item.component.scss'],
  imports: [
    ShoppingCartComponent,
    TranslatePipe
  ]
})
export class TourItemComponent implements OnInit {

  @Input({required: true}) tour!: Tour;

  constructor() {
  }

  ngOnInit() {
  }

}
